import { FC } from 'react'
import Svg, { ClipPath, Defs, G, Path, SvgProps } from 'react-native-svg'

const MealVoucherIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 32 32" width={20} height={20} fill="none" {...props}>
            <G clipPath="url(#meal-voucher-icon-clip)">
                <Path
                    fill={color}
                    d="m23.064 5.245-2.36-1.94-2.36 1.94-2.36-1.94-2.36 1.94-2.36-1.94-2.36 1.94-2.33-1.94v25.39l2.36-1.89 2.36 1.89 2.36-1.89 2.36 1.89 2.36-1.89 2.36 1.89 2.36-1.89 2.36 1.89V3.305l-2.36 1.94zm-12.62 5.2c.11-.19.28-.29.5-.31s.41.05.58.23l3.52 3.55-2.12 2.11-1.98-1.98a2.948 2.948 0 0 1-.5-3.59zm11.47 1.65q-.15 1.065-1.02 1.95c-.46.48-.99.8-1.57.94s-1.11.12-1.57-.08l-.83.82 4.56 4.55c.12.12.18.27.18.46s-.06.34-.18.46c-.13.13-.29.2-.46.2s-.33-.07-.46-.2l-4.56-4.52-4.56 4.52c-.13.13-.29.2-.46.2s-.33-.07-.46-.2a.62.62 0 0 1-.18-.46c0-.19.06-.34.18-.46l6.31-6.3c-.2-.46-.23-.98-.08-1.57.14-.58.46-1.11.94-1.57q.87-.87 1.95-1.02c.72-.1 1.3.08 1.75.53s.63 1.03.53 1.75z"
                />
            </G>
            <Defs>
                <ClipPath id="meal-voucher-icon-clip">
                    <Path fill="#fff" d="M6.574 3.305h18.85v25.39H6.574z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default MealVoucherIcon
